// Componente para exibir tela de bloqueio
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useI18n } from '@/contexts/i18n-hook';

interface LockedScreenProps {
  erroLock: string;
  apreciacaoId?: string;
}

export function LockedScreen({ erroLock, apreciacaoId }: LockedScreenProps) {
  const { t } = useI18n();

  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 border-2 border-red-200">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <Lock className="h-6 w-6 text-red-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            {t('apreciacoes.editar.bloqueio.titulo')}
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 whitespace-pre-line mb-6">
            {erroLock}
          </p>
          <div className="flex gap-3 justify-center">
            {apreciacaoId && (
              <Link
                to={`/apreciacoes/${apreciacaoId}`}
                className="px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                {t('apreciacoes.editar.bloqueio.verApreciacao')}
              </Link>
            )}
            <Link
              to="/apreciacoes"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              {t('apreciacoes.editar.bloqueio.voltarLista')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

